import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-form_item" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "c-form_item_group" }
const _hoisted_4 = ["id", "name", "value", "required", "checked"]
const _hoisted_5 = { class: "c-form_validation_required" }
const _hoisted_6 = { class: "c-form_validation_invalid" }
const _hoisted_7 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: $props.id,
      class: _normalizeClass(["c-form_label", { '-required': $props.required }])
    }, _toDisplayString($props.labelText), 11 /* TEXT, CLASS, PROPS */, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.choices, (choice, index) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("input", {
          class: "c-form_radio",
          type: "radio",
          id: choice.id,
          name: $props.name,
          value: choice.value,
          required: $props.required,
          onChange: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', $event.target.value))),
          checked: $props.modelValue === choice.value
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4),
        _createElementVNode("div", {
          class: _normalizeClass(["c-form_validation", {' -hidden': index !== $props.choices.length - 1}])
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx._t("You must select at least one option.")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx._t("This field is invalid.")), 1 /* TEXT */)
        ], 2 /* CLASS */),
        _createElementVNode("label", {
          for: choice.id,
          class: "c-form_radioLabel"
        }, _toDisplayString(choice.label), 9 /* TEXT, PROPS */, _hoisted_7)
      ]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ]))
}